export default __webpack_public_path__ + "static/media/volvo.608cb52d.svg";